import {post} from '@/http/api'

export function calculatePrice(params) {
    let {
        specification_id,
        goods_id,
        goods_num,
        orderCraftBeans,
        company_id,
        orderGoodsSpecificationInputBeans
    } = params
    let current_goods = {
        specification_id, goods_id, goods_num, orderCraftBeans
    }
    let arr = []
    orderGoodsSpecificationInputBeans.forEach(el => {
        arr.push({
            input_value: el[el.input_name],
            input_name: el.input_name
        })
    })
    current_goods.orderGoodsSpecificationInputBeans = orderGoodsSpecificationInputBeans;
    let obj = {
        order_json: JSON.stringify({
            orderGoodsBeans: [current_goods]
        }),
        company_id,
        checkout_type: 2,
    }
    return post("orderInterfaces/v1.0/checkout", obj)
}


// WEBPACK FOOTER //
// ./src/page/me/salesOrder/request.js